class CommercialService {
    axiosInstance;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    wayste = {
        setup: async () => {
            const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/setup');
            return response.data;
        },
        billingActivity: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/billing-activity', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/billing-activity/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/billing-activity`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/billing-activity/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/billing-activity/${id}`);
                return response.data;
            },
        },
        commercialSubscription: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/commercial-subscription', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/commercial-subscription/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/commercial-subscription`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/commercial-subscription/${id}`, input);
                return response.data;
            },
            cancel: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.post(`/commercial/wayste/commercial-subscription/${id}/cancel`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/commercial-subscription/${id}`);
                return response.data;
            },
        },
        commercialLineItemType: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/commercial-line-item-type', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/commercial-line-item-type/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/commercial-line-item-type`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/commercial-line-item-type/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/commercial-line-item-type/${id}`);
                return response.data;
            },
        },
        oneOffPickupRequest: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/one-off-pickup-request', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/one-off-pickup-request/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/one-off-pickup-request`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/one-off-pickup-request/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/one-off-pickup-request/${id}`);
                return response.data;
            },
        },
        servicePeriod: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('commercial/wayste/service-period', input);
                return response.data;
            },
        },
        routePlanTemplate: {
            fullSchedule: async () => {
                const response = await this.axiosInstance.mainInstance.get('/commercial/wayste/route-plan-template/full-schedule');
                return response.data;
            },
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/route-plan-template', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-plan-template/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-plan-template`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/route-plan-template/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/route-plan-template/${id}`);
                return response.data;
            },
            withSchedules: async (query) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-plan-template/with-schedules`, { params: query });
                return response.data;
            },
        },
        routeEvent: {
            stats: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-event-stats`, { params: query });
                return data;
            },
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/route-event', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-event/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-event`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/route-event/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/route-event/${id}`);
                return response.data;
            },
        },
        dailyRoutePlan: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/daily-route-plan', input);
                return response.data;
            },
            createFromTemplate: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/daily-route-plan/from-template', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/daily-route-plan/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/daily-route-plan`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/daily-route-plan/${id}`, input);
                return response.data;
            },
            reschedule: async (input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/daily-route-plan/reschedule`, input);
                return response.data;
            },
        },
        routePlanStop: {
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-plan-stop`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/daily-route-plan/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/daily-route-plan/${id}`);
                return response.data;
            },
        },
        routePlanTemplateStop: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/route-plan-template-stop', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-plan-template-stop/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/route-plan-template-stop`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/route-plan-template-stop/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/route-plan-template-stop/${id}`);
                return response.data;
            },
        },
        eventResolution: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/event-resolution', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/event-resolution/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/event-resolution`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/event-resolution/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/event-resolution/${id}`);
                return response.data;
            },
        },
        deliveryPickupRoute: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/delivery-pickup-route', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/delivery-pickup-route/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/delivery-pickup-route`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/delivery-pickup-route/${id}`, input);
                return response.data;
            },
            delete: async (id) => {
                const response = await this.axiosInstance.mainInstance.delete(`/commercial/wayste/delivery-pickup-route/${id}`);
                return response.data;
            },
        },
        deliveryPickupPlannedStop: {
            create: async (input) => {
                const response = await this.axiosInstance.mainInstance.post('/commercial/wayste/delivery-pickup-planned-stop', input);
                return response.data;
            },
            fetch: async (id) => {
                const response = await this.axiosInstance.mainInstance.get(`/commercial/wayste/delivery-pickup-planned-stop/${id}`);
                return response.data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/commercial/wayste/delivery-pickup-planned-stop`, { params: query });
                return data;
            },
            update: async (id, input) => {
                const response = await this.axiosInstance.mainInstance.patch(`/commercial/wayste/delivery-pickup-planned-stop/${id}`, input);
                return response.data;
            },
        },
    };
}
export default CommercialService;
//# sourceMappingURL=Commercial.service.js.map